<script lang="ts">
    import { COMMANDS } from "$lib/commands";
    import Search from "$lib/panels/Search.svelte";
    import MenuBar from "$lib/panels/MenuBar.svelte";
    import Tools from "$lib/panels/Tools.svelte";

    import { SplitPanel, TabPanel, GridLayout, createGridLayout } from "svelte-editor-layout/src/lib/layout";
    import { Layout } from "svelte-editor-layout";
    import { createLayout } from "$lib/panels/layout";
    import { onMount } from "svelte";
    import ToolOptionsBar from "$lib/panels/ToolOptionsBar.svelte";

    const layout = createLayout();

    document.body.classList.add("editor-variables");
    onMount(() => {
        const { add, destroy } = COMMANDS.registerActions("all");

        let panels = ["palette", "layers", "files", "history", "tool-options", "color-picker"] as const;

        for (let panel of panels) {
            add(`view.${panel}`, () => {
                layout.toggle(panel, "panel-right");
            });
        }

        return destroy;
    });
</script>

<Layout {layout}>
    <GridLayout id="editor-grid" class="desktop-layout">
        <div class="panel" style="grid-area: menu">
            <MenuBar />
        </div>

        <div class="panel" style="grid-area: tools">
            <Tools />
        </div>

        <div class="content">
            <ToolOptionsBar/>
            <slot />
        </div>

        <TabPanel id="panel-bottom" class="panel" />

        <SplitPanel id="panel-right" class="panel" />

    </GridLayout>
</Layout>

<!--Overlay-->
<Search />


<style>
    :global(body, .desktop-layout) {
        background-color: var(--gap-color);
        height: 100vh;
        height: 100dvh;
        overflow: hidden;

        & > :global(.panel) {
            background: var(--g100);
        }
    }

    .content {
        grid-area: content;
        overflow: hidden;
        background: unset;
        display: grid;
        grid-template-rows: max-content 1fr;
    }
</style>
